import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/manrope';
import '@fontsource/instrument-serif/400.css';
import App from './App';
import '@/styles/globals.css';
import { installGlobalErrorHandlers } from '@/utils/clientLogger';

installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
